import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { faCheck, faExclamation,faCircleCheck,faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { BloodMarkerModal } from "./BloodMarkerModal";
import "../../../assets/scss/_blood-marker-card.scss";
import { getStatusSexualHealth } from "./HealthAreaSection";
import MarkerScale from "./MarkerScale";
import { useMediaQuery } from "react-responsive";
import successIcon from "../../../assets/icons/Step_success.svg"

/**
 * BloodMarkerCard component
 * Displays a card for a blood marker with its value and status.
 * Includes a modal for additional information.
 *
 * @returns {JSX.Element} The rendered blood marker card.
 */

export function BloodMarkerCard({ marker, report_type, onSeeDetails }) {
  const [modalOpened, setModalOpened] = useState(false);
  const historicalData = marker?.historical_data || null;

  const toggleModal = () => setModalOpened(!modalOpened);

  // Don't render partial markers
  if (marker?.partial === "true") {
    return null;
  }

  return (
    <div className={`markerCard__container markerCard__${marker?.type}`}>
      {marker?.type === "negative-positive" ? (
        
        <PositiveNegativeCard
          marker={marker}
          toggleModal={toggleModal}
          report_type={report_type}
        />
      ) : (
        <GenericMarkerCard
          marker={marker}
          toggleModal={toggleModal}
          onSeeDetails={onSeeDetails}
          report_type={report_type}
        />
      )}

      {/* Modal */}
      <BloodMarkerModal
        marker={marker}
        isOpen={modalOpened}
        toggle={toggleModal}
      />
    </div>
  );
}

BloodMarkerCard.propTypes = {
  marker: PropTypes.shape({
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    units: PropTypes.string,
    result: PropTypes.string,
    partial: PropTypes.string,
  }).isRequired,
  report_type: PropTypes.string,
  onSeeDetails: PropTypes.func,
};

/**
 * GenericMarkerCard component.
 * Renders a card for a generic blood marker, showing its value and status.
 *
 * @returns {JSX.Element} The rendered generic marker card.
 */

function GenericMarkerCard({ marker, toggleModal,onSeeDetails, report_type }) {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const markerValue =
    typeof marker?.value === "number"
      ? marker?.value?.toFixed(2)
      : marker?.value;
  let statusIcon = faExclamation;
  let status = marker?.result;

  if (["normal", "green"].includes(marker?.result)) {
    statusIcon = faCheck;
    status = "normal";
  }

  // if (
  //   isMobile &&
  //   marker.code === "B12A" &&
  //   report_type === "boots-blood-vitamin-b12"
  // ) {
  //   return (
  //     <>
  //       {/* Header */}
  //       <header className="markerCard__header--b12 ">
  //         <div className="d-flex justify-content-center">
  //           <span
  //             className={`markerCard__header-status--b12 markerCard__header-status--b12--${status} g-2`}
  //           >
  //             <FontAwesomeIcon
  //               data-testid={
  //                 statusIcon === faCheck ? "fa-check" : "fa-exclamation"
  //               }
  //               icon={statusIcon}
  //             />
  //           </span>
  //           <h2
  //             className="markerCard__title--b12"
  //             id={`tooltip-${marker?.code}`}
  //           >
  //             {marker?.name}
  //             <small className="b12">({marker?.code})</small>
  //           </h2>
  //         </div>

  //         {marker?.type !== "negative-positive" && (
  //           <div className="markerCard__value--b12">
  //             {Number.parseFloat(markerValue).toFixed(2)}{" "}
  //             {marker?.units && (
  //               <span className="markerCard__unit">{marker?.units}</span>
  //             )}
  //           </div>
  //         )}
  //       </header>

  //       {/* Main content */}
  //       <div className="markerCard__content b12_marker_range">
  //         <div className="markerCard__scale">
  //           <MarkerScale {...marker} />
  //         </div>
  //         <Button className="btn-white" onClick={() => onSeeDetails?.(marker?.code)}  size="sm">
  //           See details
  //         </Button>
  //       </div>
  //       {/* <Button
  //         className="markerCard__button--b12"
  //         onClick={toggleModal}
  //         size="sm"
  //       >
  //         Read more
  //       </Button> */}
  //     </>
  //   );
  // }

  return (
    <>
      {/* {JSON.stringify(marker)} */}
      {/* Header */}
      <header className="markerCard__header">
        <span
          className={`markerCard__header-status markerCard__header-status--${status}`}
        >
          {isMobile ? (
            <img src={successIcon} alt="success icon" />
          ) : (
            <FontAwesomeIcon
              data-testid={statusIcon === "fa-check"}
              icon={faCheck}
            />
          )}
        </span>
        <h2 className="markerCard__title" id={`tooltip-${marker?.code}`}>
          {`${marker?.name}`}
        </h2>
      </header>

      {/* Main content */}
      <div className="markerCard__content">
        <div className="markerCard__scale">
          <MarkerScale {...marker} />
        </div>
        <Button
          className="btn-white"
          onClick={() => onSeeDetails?.(marker?.code)}
          size="sm"
        >
          See details
        </Button>
      </div>
    </>
  );
}

GenericMarkerCard.propTypes = {
  marker: PropTypes.shape({
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    units: PropTypes.string,
    result: PropTypes.string,
  }).isRequired,
  toggleModal: PropTypes.func.isRequired,
  report_type: PropTypes.string,
  onSeeDetails: PropTypes.func,
};

function toTitleCase(str) {
  return str.replaceAll(/\b(\w)/g, (k) => k.toUpperCase());
}
function PositiveNegativeCard({ marker, toggleModal }) {
  let status = getStatusSexualHealth([marker]);

  return (
    <div className="markerCard__content">
      <h2
        className="markerCard__title d-flex gap-2 align-items-center"
        id={`tooltip-${marker.code}`}
      >
        <span className="markerCard__header__section d-flex align-items-center">
          <span
            className={`markerCard__header-status markerCard__header-status--always`}
          >
            <FontAwesomeIcon icon={faCheck} />
          </span>
          <span style={{marginTop: "3px"}}>{marker.name}</span>
        </span>
        <div className={`markerCard__result_container markerCard__result_container--${status}`}>
          <span
            className={`markerCard__header-status markerCard__header-status--${status}`}
          >
            {status === "normal" ? (
              <FontAwesomeIcon
                icon={faCircleCheck}
                style={{ color: "#003032" }}
              />
            ) : (
              <FontAwesomeIcon
                icon={faCircleExclamation}
                style={{ color: "#003032" }}
              />
            )}
          </span>
          <span className="marker__value_result" style={{paddingTop: "2px"}}>{toTitleCase(marker.value.toString().replaceAll("**", "") || "")}</span>
        </div>
      </h2>
      <Button className={`btn-white mt-0`} onClick={toggleModal} size="sm">
        Learn more
      </Button>
    </div>
  );
}

PositiveNegativeCard.propTypes = {
  marker: PropTypes.shape({
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    units: PropTypes.string,
    result: PropTypes.string,
  }).isRequired,
  toggleModal: PropTypes.func.isRequired
};
